import {
  Avatar,
  Button,
  Card,
  Col,
  Form,
  Image,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Skeleton,
  Space,
  Switch,
} from "antd";
import axios from "axios";
import _, { debounce } from "lodash";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import {
  CloseOutlined,
  GiftOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory, useParams } from "react-router-dom";
import ShopLayout from "../Layout";
import ShopHeader from "../Layout/topHeader";
import { useSelector } from "react-redux";
import FreeProductAssignList from "./freeProducts";
import ImageUploader from "../../FileManager/upload";
const { Option } = Select;

interface AddProductProps {
  productSlug?: any;
}

const AddShopProduct = (props: AddProductProps) => {
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  const [convertedText, setConvertedText] = useState("");
  const [type, setType] = useState(shopInfo?.type);
  const [visible, setVisible] = useState(undefined);
  const [selectedProduct, setSelectedProduct] = useState<any>(undefined);

  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);
  const [startUpload2, setStartUpload2] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);
  const [generatedImgUrl, setGeneratedImgUrl] = useState<string>();
  const [generatedThumbUrl, setGeneratedThumbUrl] = useState<string>();

  const { productSlug } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState<boolean>();
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [discountImageUrl, setDiscountImageUrl] = useState<string[]>([]);
  const [thumbImageUrl, setThumbImageUrl] = useState<string>();
  const [variationImageUrl, setVariationImageUrl] = useState<string[]>([]);
  const [singleProductInfo, setSingleProductInfo] = useState({
    loading: false,
    data: null,
  });
  const [discountType, setDiscountType] = useState<{
    [key: string]: { type: "disFlat" | "disPercentage" | null; value: number };
  }>({});
  const [qtyDiscountType, setQtyDiscountType] = useState<{
    [key: string]: {
      type: "freeProduct" | "qtyFlat" | "qtyPercentage" | null;
      value: number;
      minimumQuantity: number;
    };
  }>({});

  const [campaignOptions, setCampaignOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [categoryOptions, setCategoryOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [suppliersOptions, setSuppliersOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const history = useHistory();
  const route = useParams();

  useEffect(() => {
    if (startUpload === "Uploaded" && startUpload2 === "Uploaded") {
      form?.submit();
    }
  }, [form, startUpload, startUpload2]);

  const fetchProductDetails = useCallback((getProductId) => {
    if (getProductId) {
      try {
        setSingleProductInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/product/details?slug=${getProductId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleProductInfo({
                loading: false,
                data: data?.data?.product,
              });
              setConvertedText(data?.data?.product?.description || "");
              setVariationImageUrl(
                data?.data?.product?.variations?.map((item) => item?.imageUrl)
              );
              setDiscountImageUrl(
                data?.data?.product?.variations?.map(
                  (item) =>
                    item?.quantitativeProductDiscount?.freeProduct?.productImage
                )
              );
              setIsActive(data?.data?.product?.isActive);
              setGeneratedThumbUrl(data?.data?.product?.productImage);
              setGeneratedImgUrl(data?.data?.product?.images?.[0]);

              const diss = {};
              data?.data?.product?.variations?.map((va, i) => {
                diss[i] = {
                  type: va?.productDiscount?.flat
                    ? "disFlat"
                    : va?.productDiscount?.percentage
                    ? "disPercentage"
                    : null,
                  value:
                    va?.productDiscount?.flat ||
                    va?.productDiscount?.percentage ||
                    0,
                };
              });
              const qtyDis = {};
              data?.data?.product?.variations?.map((va, i) => {
                qtyDis[i] = {
                  type: va?.quantitativeProductDiscount?.freeProduct
                    ? "freeProduct"
                    : va?.quantitativeProductDiscount?.productDiscount?.flat
                    ? "qtyFlat"
                    : va?.quantitativeProductDiscount?.productDiscount
                        ?.percentage
                    ? "qtyPercentage"
                    : null,
                  value:
                    va?.quantitativeProductDiscount?.freeProduct ||
                    va?.quantitativeProductDiscount?.productDiscount?.flat ||
                    va?.quantitativeProductDiscount?.productDiscount
                      ?.percentage ||
                    0,
                  minimumQuantity:
                    va?.quantitativeProductDiscount?.minimumQuantity,
                };
              });

              setDiscountType(diss);
              setQtyDiscountType(qtyDis);
            } else {
              setSingleProductInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleProductInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleProductInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  const onSubmit = async (data) => {
    if (generatedImgUrl || generatedThumbUrl) {
      setLoading(true);
      const readyData = data && {
        barCode: data.barCode,
        name: data.name, 
        type: shopInfo?.type,
        categoryId: data.categoryId,
        brandId: data.brandId || 0,
        shopId: (route as any).shopId,
        supplierId: data.supplierId,
        campaignId: data.campaignId,
        keyword: data.keyword,
        isPopular: data.isPopular,
        bookingEnabled: data.bookingEnabled,
        displayOrder: parseInt(data.displayOrder),
        excludeFromPromo: data.excludeFromPromo,
        description: convertedText || "<p></p>",
        productImage:
          generatedThumbUrl || singleProductInfo?.data?.productImage,
        images: generatedImgUrl
          ? generatedImgUrl
          : singleProductInfo?.data?.images,
        isActive: isActive,
        variations: data?.variations?.map((variant) => ({
          variationName: variant.variationName,
          imageUrl: variant.imageUrl,
          barCode: variant.barCode || data.barCode,
          variationId: variant.variationId || data.variationId,
          maximumOrderLimit: variant.maximumOrderLimit
            ? parseInt(variant.maximumOrderLimit)
            : undefined,
          price: {
            mrp: parseFloat(variant.mrp) * 1,
            tp: parseFloat(variant.tp) * 1,
          },
          productDiscount: {
            flat: parseFloat(variant.flat) || null,
            percentage: parseFloat(variant.percentage) || null,
          },
          quantitativeProductDiscount: {
            freeProductId: selectedProduct?.id || variant.freeProductId,
            minimumQuantity: variant.minimumQuantity || null,
            productDiscount: {
              flat: parseFloat(variant?.productDiscount?.qtyFlat) || null,
              percentage:
                parseFloat(variant?.productDiscount?.qtyPercentage) || null,
            },
          },
          stock: parseFloat(variant.stock) || 0,
        })),
      };

      if (singleProductInfo?.data) {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/product`, {
          method: "PUT", 
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...readyData,
            id: singleProductInfo?.data?.id, 
            isActive: isActive,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Product Updated Successfully", "success");
              form.resetFields();
              history?.goBack();
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      } else {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/product`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Product Create Successfully", "success");
              form.resetFields();
              history?.goBack();
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      }
    } else {
      responseNotification(`Product Thumbnail & Image required`, "error");
    }
  };
  // **********************************
  // Search Options
  // **********************************

  const getCampaignOptions = useCallback(
    async (val?: string) => {
      setCampaignOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/campaign/all?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setCampaignOptions({
        loading: false,
        list: res?.data?.campaigns?.map((campaign) => {
          return {
            value: campaign?.id,
            label: campaign?.name,
          };
        }),
      });
    },
    [type]
  );

  const getCategoriesOptions = useCallback(
    async (val?: string) => {
      if (shopInfo?.type === "JC_MART") {
        setCategoryOptions({ loading: true, list: [] });
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/category/child-category-by-hub?hubId=${shopInfo?.hubId}` +
            (val ? `&key=${val}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );

        setCategoryOptions({
          loading: false,
          list: res?.data?.categories?.map((category) => {
            return {
              value: category?.id,
              label: category?.title,
            };
          }),
        });
      } else {
        setCategoryOptions({ loading: true, list: [] });
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/category/child-category-by-shop?shopId=${shopInfo?.id}` +
            (type ? `&type=${type}` : ``) +
            (val ? `&key=${val}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoryOptions({
          loading: false,
          list: res?.data?.categories?.map(
            (category: { id: any; title: any }) => {
              return {
                value: category?.id,
                label: category?.title,
              };
            }
          ),
        });
      }
    },
    [type]
  );

  const getBrandsOptions = useCallback(
    async (val?: string) => {
      setBrandsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),

        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setBrandsOptions({
        loading: false,
        list: res?.data?.brands?.map((brand) => {
          return {
            value: brand?.id,
            label: brand?.name,
          };
        }),
      });
    },
    [type]
  );

  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/shop/admin/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop) => {
          return {
            id: shop?.id,
            name: shop?.name,
          };
        }),
      });
    },
    [type]
  );

  const getSupplierOptions = useCallback(
    async (val?: string) => {
      setSuppliersOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/supplier/by-shop?shopId=${shopInfo?.id}&page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setSuppliersOptions({
        loading: false,
        list: res?.data?.suppliers?.map((supplier) => {
          return {
            value: supplier?.id,
            label: supplier?.name,
          };
        }),
      });
    },
    [type]
  );

  useEffect(() => {
    if (type) {
      getCategoriesOptions();
      getBrandsOptions();
      getShopsOptions();
      getSupplierOptions();
      getCampaignOptions();
    }
  }, [
    getBrandsOptions,
    getCategoriesOptions,
    getShopsOptions,
    getSupplierOptions,
    getCampaignOptions,
    type,
  ]);

  const fetchRef = useRef(null);

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      if (fetchId !== fetchRef.current) {
        return;
      }
      if (type) {
        if (value) {
          if (field === "category") getCategoriesOptions(value);
          else if (field === "brand") getBrandsOptions(value);
          else if (field === "shop") getShopsOptions(value);
          else if (field === "supplier") getSupplierOptions(value);
          else if (field === "campaign") getCampaignOptions(value);
        }
      } else {
        responseNotification("Select a type before search", "warning");
      }
    };

    return debounce(loadOptions, 800);
  }, [
    getCategoriesOptions,
    getBrandsOptions,
    getShopsOptions,
    getSupplierOptions,
    getCampaignOptions,
    type,
  ]);
  // **********************************
  // Search Options
  // **********************************

  useEffect(() => {
    fetchProductDetails(productSlug || (route as any).slug);
  }, [fetchProductDetails, productSlug, route]);

  useEffect(() => {
    if (singleProductInfo?.data) {
      form.resetFields(Object.keys(singleProductInfo?.data));
      setThumbImageUrl(singleProductInfo?.data?.productImage);
      setImageUrls(singleProductInfo?.data?.images || []);
      setVariationImageUrl(
        singleProductInfo?.data?.variations?.map((item) => item?.imageUrl)
      );
      setDiscountImageUrl(
        singleProductInfo?.data?.variations?.map(
          (item) => item?.quantitativeProductDiscount?.freeProduct?.productImage
        )
      );
    }
  }, [form, singleProductInfo?.data]);

  const resetData = () => {
    form?.resetFields();
    setImageUrls([]);
    setDiscountImageUrl([]);
    setThumbImageUrl("");
    setVariationImageUrl([]);
    setType("");
    setGeneratedImgUrl(undefined);
    setGeneratedThumbUrl(undefined);
    setStartUpload(undefined);
    setStartUpload2(undefined);
  };

  return (
    <>
      <ShopLayout shopId={(route as any)?.shopId as string}>
        <div className="bg-white">
          <ShopHeader
            leftarea={singleProductInfo?.data ? "Edit Product" : "Add Product"}
            rightarea={
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  history?.goBack();
                }}
                type="text"
              >
                <CloseOutlined />
              </Button>
            }
          />
          {singleProductInfo?.loading ? (
            <>
              <Skeleton avatar active paragraph={{ rows: 20 }} />
            </>
          ) : (
            <div className="product-add">
              <div className="info-body">
                <div className="inner-body">
                  <div className="add-product drawer-toggle-wrapper">
                    <div className="drawer-toggle-inner-wrapper">
                      <Form
                        name="control-hooks"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        className="ant-form ant-form-vertical"
                        onFinish={onSubmit}
                        initialValues={{
                          ...singleProductInfo?.data,
                          type: type || singleProductInfo?.data?.shop?.type,
                        }}
                        form={form} // like ref
                        layout="vertical"
                        autoComplete="off"
                      >
                        <Form.Item
                          hasFeedback
                          label="Product Barcode"
                          name="barCode"
                        >
                          <Input
                            id="barCode"
                            type="text"
                            placeholder="Scan Barcode"
                          />
                        </Form.Item>

                        <Form.Item
                          hasFeedback
                          label="Product Name"
                          rules={[
                            {
                              required: true,
                              message: "Product Name is Required!",
                            },
                          ]}
                          name="name"
                        >
                          <Input
                            id="name"
                            type="text"
                            placeholder="Enter Product Name"
                          />
                        </Form.Item>

                        <Form.Item
                          hasFeedback
                          label="Campaign"
                          rules={[
                            {
                              required: false,
                              message: "Sub Category is required!",
                            },
                          ]}
                          name="campaignId"
                        >
                          <Select
                            allowClear
                            showSearch
                            placeholder="Select Campaign"
                            optionFilterProp="children"
                            onSearch={(val) => {
                              handleSearch?.(val, "campaign");
                            }}
                            filterOption={(inputValue, option) =>
                              option.children.indexOf(inputValue as any) >= 0
                            }
                            options={campaignOptions?.list}
                          >
                            {campaignOptions?.list?.map((campaign) => (
                              <Option
                                value={campaign?.value}
                                key={campaign?.value}
                              >
                                {campaign?.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          hasFeedback
                          label={`Sub Category (${singleProductInfo?.data?.category?.title})`}
                          rules={[
                            {
                              required: true,
                              message: "Sub Category is required!",
                            },
                          ]}
                          name="categoryId"
                        >
                          <Select
                            showSearch
                            placeholder="Select Sub Category"
                            optionFilterProp="children"
                            onSearch={(val) => {
                              handleSearch?.(val, "category");
                            }}
                            filterOption={(inputValue, option) =>
                              option.children.indexOf(inputValue as any) >= 0
                            }
                            // options={categoryOptions?.list}
                          >
                            {categoryOptions?.list?.map((category) => (
                              <Option
                                value={category?.value}
                                key={category?.value}
                              >
                                {category?.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          hasFeedback
                          label={`Brand (${singleProductInfo?.data?.brand?.name})`}
                          name="brandId"
                        >
                          <Select
                            showSearch
                            placeholder="Select Brand"
                            optionFilterProp="children"
                            // onChange={(val) => setBrandId(val)}
                            onSearch={(val) => {
                              handleSearch(val, "brand");
                            }}
                            filterOption={(input, option) =>
                              option.children
                                .toString()
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            // options={brandsOptions?.list}
                          >
                            {brandsOptions?.list?.map((brand) => (
                              <Option value={brand?.value} key={brand?.value}>
                                {brand?.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          hasFeedback
                          label={`Supplier (${suppliersOptions?.data?.brand?.name})`}
                          name="supplierId"
                        >
                          <Select
                            showSearch
                            placeholder="Select Supplier"
                            optionFilterProp="children"
                            onSearch={(val) => {
                              handleSearch(val, "supplier");
                            }}
                            filterOption={(input, option) =>
                              option.children
                                .toString()
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {suppliersOptions?.list?.map((supplier) => (
                              <Option
                                value={supplier?.value}
                                key={supplier?.value}
                              >
                                {supplier?.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          hasFeedback
                          label="Display Order"
                          rules={[
                            {
                              required: false,
                              message: "displayOrder is Required!",
                            },
                          ]}
                          name="displayOrder"
                        >
                          <Input
                            id="displayOrder"
                            type="text"
                            placeholder="Enter Display Order"
                          />
                        </Form.Item>

                        <Form.Item
                          hasFeedback
                          label="Keywords"
                          rules={[
                            {
                              required: true,
                              message: "Keywords is Required!",
                            },
                          ]}
                          name="keyword"
                        >
                          <Input
                            id="keyword"
                            type="text"
                            placeholder="Enter Product Keywords"
                          />
                        </Form.Item>

                        <h6
                          className="p-0 font-weight-bold"
                          style={{ width: "100%" }}
                        >
                          Product Details
                        </h6>
                        <ReactQuill
                          theme="snow"
                          value={convertedText}
                          onChange={setConvertedText}
                          style={{
                            minHeight: "200px",
                            width: "100%",
                            marginBottom: 60,
                          }}
                        />

                        <h4 className="title">Product Variations</h4>
                        <Form.List
                          name="variations"
                          rules={[
                            {
                              validator: async (_, names) => {
                                if (!names || names.length < 1) {
                                  return Promise.reject(
                                    new Error("At least 1 variation required!")
                                  );
                                }
                              },
                            },
                          ]}
                        >
                          {(fields, { add, remove }, { errors }) => (
                            <>
                              {fields.map(
                                ({
                                  key,
                                  name,
                                  fieldKey,
                                  ...restField
                                }: any) => (
                                  <Card className="mb-2" size="small" key={key}>
                                    <Space wrap align="center">
                                      {variationImageUrl && (
                                        <div>
                                          <Avatar
                                            src={variationImageUrl[name]}
                                            shape="square"
                                            size="large"
                                          />
                                        </div>
                                      )}
                                      <Form.Item
                                        {...restField}
                                        name={[name, "imageUrl"]}
                                        fieldKey={[fieldKey, "imageUrl"]}
                                        hasFeedback
                                        label="Variation Image"
                                        style={{ width: 110 }}
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.imageUrl
                                        }
                                      >
                                        <Input
                                          placeholder="Enter Image"
                                          onChange={async (e) => {
                                            setVariationImageUrl((prev) => {
                                              const newArr = Array.from(prev);
                                              newArr[name] = e.target.value;
                                              return newArr;
                                            });
                                          }}
                                        />
                                      </Form.Item>

                                      <Form.Item
                                        {...restField}
                                        name={[name, "barCode"]}
                                        fieldKey={[fieldKey, "barCode"]}
                                        hasFeedback
                                        label="Barcode"
                                        style={{ width: 100 }}
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.barCode
                                        }
                                      >
                                        <Input placeholder="Enter Barcode" />
                                      </Form.Item>

                                      <Form.Item
                                        {...restField}
                                        name={[name, "variationId"]}
                                        fieldKey={[fieldKey, "variationId"]}
                                        hasFeedback
                                        label="ID"
                                        style={{ width: 80 }}
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.variationId
                                        }
                                      >
                                        <Input
                                          id="variationId"
                                          placeholder="Enter ID"
                                          disabled={singleProductInfo?.data}
                                        />
                                      </Form.Item>

                                      <Form.Item
                                        {...restField}
                                        name={[name, "variationName"]}
                                        fieldKey={[fieldKey, "variationName"]}
                                        hasFeedback
                                        label="Variation/Unit"
                                        rules={[
                                          {
                                            required: true,
                                            message: "Required!",
                                          },
                                        ]}
                                        style={{ width: 100 }}
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.variationName
                                        }
                                      >
                                        <Input placeholder="1pc/5kg/1pkt" />
                                      </Form.Item>

                                      <Form.Item
                                        {...restField}
                                        name={[name, "mrp"]}
                                        fieldKey={[fieldKey, "mrp"]}
                                        hasFeedback
                                        label="MRP"
                                        style={{ width: 70 }}
                                        rules={[
                                          {
                                            required: true,
                                            message: "Required!",
                                          },
                                        ]}
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.price?.mrp
                                        }
                                      >
                                        <Input placeholder="Enter MRP" />
                                      </Form.Item>

                                      <Form.Item
                                        {...restField}
                                        name={[name, "tp"]}
                                        fieldKey={[fieldKey, "tp"]}
                                        hasFeedback
                                        label="TP"
                                        style={{ width: 70 }}
                                        rules={[
                                          {
                                            required: true,
                                            message: "Required!",
                                          },
                                        ]}
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.price?.tp
                                        }
                                      >
                                        <Input placeholder="Enter TP" />
                                      </Form.Item>

                                      <Form.Item
                                        {...restField}
                                        name={[name, "maximumOrderLimit"]}
                                        fieldKey={[
                                          fieldKey,
                                          "maximumOrderLimit",
                                        ]}
                                        hasFeedback
                                        label="Max Limit"
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.maximumOrderLimit
                                        }
                                        style={{ width: 80 }}
                                      >
                                        <Input placeholder="Maximum Order Limit" />
                                      </Form.Item>

                                      <Form.Item
                                        {...restField}
                                        name={[name, "stock"]}
                                        fieldKey={[fieldKey, "stock"]}
                                        hasFeedback
                                        label="Stock"
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.stock
                                        }
                                        rules={[
                                          {
                                            required: true,
                                            message: "Required!",
                                          },
                                        ]}
                                        style={{ width: 70 }}
                                      >
                                        <Input placeholder="Stock" />
                                      </Form.Item>
                                    </Space>

                                    <Space wrap align="center" className="mb-3">
                                      <h6 className="bg-success rounded text-white px-2 mb-0">
                                        General Discount
                                      </h6>
                                      <Radio.Group
                                        value={discountType[name]?.type}
                                        onChange={(e) => {
                                          setDiscountType(() => {
                                            const temp = {};
                                            temp[name] = {
                                              type: e.target.value,
                                              value: undefined,
                                            };
                                            return temp;
                                          });
                                        }}
                                        name="productDiscount"
                                      >
                                        <Radio value={null}>None</Radio>
                                        <Radio value={`disFlat`}>Flat</Radio>

                                        <Radio value={`disPercentage`}>
                                          Percentage
                                        </Radio>
                                      </Radio.Group>
                                      <div className="">
                                        {console.log("disc", discountType)}
                                        {discountType[name]?.type ===
                                          "disFlat" && (
                                          <Form.Item
                                            {...restField}
                                            name={[name, "flat"]}
                                            fieldKey={[fieldKey, "flat"]}
                                            initialValue={
                                              discountType?.[name]?.value
                                            }
                                            hasFeedback
                                            style={{
                                              width: 100,
                                              marginBottom: 0,
                                            }}
                                          >
                                            <Input
                                              placeholder="Flat (Tk.)"
                                              size="small"
                                            />
                                          </Form.Item>
                                        )}

                                        {discountType?.[name]?.type ===
                                          "disPercentage" && (
                                          <Form.Item
                                            {...restField}
                                            name={[name, "percentage"]}
                                            fieldKey={[fieldKey, "percentage"]}
                                            hasFeedback
                                            initialValue={
                                              discountType?.[name]?.value
                                            }
                                            style={{
                                              width: 100,
                                              marginBottom: 0,
                                            }}
                                          >
                                            <Input
                                              placeholder="Percent (%)"
                                              size="small"
                                            />
                                          </Form.Item>
                                        )}
                                      </div>
                                    </Space>

                                    <Space wrap key={key} align="center">
                                      <h6 className="bg-success rounded text-white px-2 mb-0">
                                        Quantitive Discount
                                      </h6>

                                      <Radio.Group
                                        value={qtyDiscountType?.[name]?.type}
                                        onChange={(val) => {
                                          setQtyDiscountType(() => {
                                            const temp = {};
                                            temp[name] = {
                                              type: val.target.value,
                                              value: undefined,
                                              minimumQuantity: undefined,
                                            };
                                            return temp;
                                          });
                                        }}
                                        name="quantitiveProductDiscount"
                                      >
                                        <Radio value={null}>None</Radio>
                                        <Radio value={`qtyFlat`}>Flat</Radio>
                                        <Radio value={`qtyPercentage`}>
                                          Percentage
                                        </Radio>
                                        <Radio value="freeProduct">
                                          Free Product
                                        </Radio>
                                      </Radio.Group>

                                      <Space wrap key={key} align="center">
                                        {qtyDiscountType?.[name]?.type !==
                                          null && (
                                          <Form.Item
                                            {...restField}
                                            name={[name, "minimumQuantity"]}
                                            fieldKey={[
                                              fieldKey,
                                              "minimumQuantity",
                                            ]}
                                            hasFeedback
                                            initialValue={
                                              qtyDiscountType?.[name]
                                                ?.minimumQuantity
                                            }
                                            style={{
                                              width: 100,
                                              marginBottom: 0,
                                            }}
                                          >
                                            <Input
                                              placeholder="Min Quantity"
                                              size="small"
                                            />
                                          </Form.Item>
                                        )}

                                        {qtyDiscountType?.[name]?.type ===
                                          "freeProduct" &&
                                          (qtyDiscountType?.[name]?.value ||
                                          selectedProduct?.productImage ? (
                                            <div className="d-flex align-items-start">
                                              {discountImageUrl && (
                                                <Avatar
                                                  src={
                                                    <Image
                                                      src={
                                                        selectedProduct?.productImage ||
                                                        discountImageUrl[name]
                                                      }
                                                    />
                                                  }
                                                  shape="square"
                                                  size="large"
                                                  className="border"
                                                />
                                              )}
                                              <Button
                                                danger
                                                type="text"
                                                onClick={() =>
                                                  setSelectedProduct(undefined)
                                                }
                                                size="large"
                                              >
                                                <CloseOutlined />
                                              </Button>
                                            </div>
                                          ) : (
                                            <Button
                                              type="dashed"
                                              onClick={() => setVisible(true)}
                                              size="large"
                                            >
                                              <GiftOutlined /> Free Product
                                            </Button>
                                          ))}

                                        {qtyDiscountType?.[name]?.type ===
                                          "qtyFlat" && (
                                          <Form.Item
                                            {...restField}
                                            name={[name, "qtyFlat"]}
                                            fieldKey={[fieldKey, "flat"]}
                                            hasFeedback
                                            initialValue={
                                              qtyDiscountType?.[name]?.value
                                            }
                                            style={{
                                              width: 100,
                                              marginBottom: 0,
                                            }}
                                          >
                                            <Input
                                              placeholder="Flat (Tk.)"
                                              size="small"
                                            />
                                          </Form.Item>
                                        )}

                                        {qtyDiscountType?.[name]?.type ===
                                          "qtyPercentage" && (
                                          <Form.Item
                                            {...restField}
                                            name={[name, "qtyPercentage"]}
                                            fieldKey={[fieldKey, "percentage"]}
                                            hasFeedback
                                            // label="Percentage Discount"
                                            initialValue={
                                              qtyDiscountType?.[name]?.value
                                            }
                                            style={{
                                              width: 100,
                                              marginBottom: 0,
                                            }}
                                          >
                                            <Input
                                              placeholder="Percent (%)"
                                              size="small"
                                            />
                                          </Form.Item>
                                        )}
                                      </Space>
                                    </Space>

                                    <Button
                                      type="primary"
                                      danger
                                      style={{
                                        position: "absolute",
                                        right: 0,
                                        top: 0,
                                      }}
                                      onClick={() => {
                                        remove(name);
                                        setVariationImageUrl((prev) => {
                                          const newArr = prev.filter(
                                            (_, i) => i !== name
                                          );
                                          return newArr;
                                        });
                                      }}
                                    >
                                      <MinusCircleOutlined />
                                    </Button>
                                  </Card>
                                )
                              )}

                              <Form.Item
                                style={{
                                  width: "100%",
                                  flex: "1 1 100%",
                                  marginBottom: 5,
                                }}
                              >
                                <Button
                                  type="dashed"
                                  onClick={() => {
                                    add();
                                    setVariationImageUrl((prev) => {
                                      const newArr = Array.from(prev);
                                      newArr.push("");
                                      return newArr;
                                    });
                                  }}
                                  block
                                  icon={<PlusOutlined />}
                                >
                                  Add Variation
                                </Button>
                              </Form.Item>

                              <Form.ErrorList errors={errors} />
                            </>
                          )}
                        </Form.List>

                        <Row gutter={20} style={{ minWidth: "100%" }}>
                          <Col span={24}>
                            <h4 className="title">Product Images</h4>
                            <div className="d-flex justify-content-start align-items-start">
                              <div className="mr-3">
                                <p className="mb-1">Thumbnail</p>
                                <ImageUploader
                                  crop={1}
                                  imgUrl={generatedThumbUrl || ""}
                                  startUpload={startUpload}
                                  setStartUpload={(val) => setStartUpload(val)}
                                  setGeneratedImgUrl={(url) =>
                                    setGeneratedThumbUrl(url)
                                  }
                                />
                              </div>
                              <div className="">
                                <p className="mb-1">Images:</p>
                                <ImageUploader
                                  multiple
                                  imgUrl={imageUrls || []}
                                  startUpload={startUpload2}
                                  setStartUpload={(val) => setStartUpload2(val)}
                                  setGeneratedImgUrl={(url) =>
                                    setGeneratedImgUrl(url)
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col span={24}>
                            <h4 className="title">Extra</h4>
                            <div className="grid_3x">
                              <div className="">
                                <Form.Item
                                  hasFeedback
                                  label="Exclude From Promo?"
                                  name="excludeFromPromo"
                                >
                                  <Switch
                                    checkedChildren={`Exclude`}
                                    unCheckedChildren={`Include`}
                                    defaultChecked={
                                      (singleProductInfo as any)?.data
                                        ?.excludeFromPromo
                                    }
                                  />
                                </Form.Item>
                              </div>
                              <div className="">
                                <Form.Item
                                  hasFeedback
                                  label="Pre-Order?"
                                  name="bookingEnabled"
                                  className="mr-5"
                                >
                                  <Switch
                                    checkedChildren={`Yes`}
                                    unCheckedChildren={`Not Sure`}
                                    defaultChecked={
                                      (singleProductInfo as any)?.data
                                        ?.bookingEnabled
                                    }
                                  />
                                </Form.Item>
                              </div>
                              <div className="">
                                <Form.Item
                                  hasFeedback
                                  label="Popular Product?"
                                  name="isPopular"
                                  className="mr-5"
                                >
                                  <Switch
                                    checkedChildren={`Yes`}
                                    unCheckedChildren={`Not Sure`}
                                    defaultChecked={
                                      (singleProductInfo as any)?.data
                                        ?.isPopular
                                    }
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <div className="buttons-container">
                          <Button
                            disabled={
                              loading ||
                              startUpload === "Uploading" ||
                              startUpload2 === "Uploading"
                            }
                            loading={
                              loading ||
                              startUpload === "Uploading" ||
                              startUpload2 === "Uploading"
                            }
                            type="primary"
                            htmlType="submit"
                            className="add-submit-btn text-center mr-2"
                            onClick={(e) => {
                              e.preventDefault();
                              setStartUpload("Uploading");
                              setStartUpload2("Uploading");
                            }}
                          >
                            Submit
                          </Button>
                          <Button
                            type="ghost"
                            htmlType="button"
                            onClick={resetData}
                            className="reset-submit-btn text-center mr-2"
                          >
                            Reset
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </ShopLayout>
      <Modal
        title="Assign Free Product"
        centered
        visible={visible}
        okText="Assign as Free"
        okType="primary"
        onOk={() => {
          setVisible(false);
        }}
        destroyOnClose
        onCancel={() => {
          setVisible(false);
        }}
        width={"90%"}
        className="orderProductModal"
      >
        <FreeProductAssignList
          shop={shopInfo?.id}
          selectedProduct={selectedProduct}
          setSelectedProduct={async (products) => {
            setSelectedProduct(products);
          }}
        />
      </Modal>
    </>
  );
};
AddShopProduct.propTypes = {
  visibleData: PropTypes.any,
  onCloseMethod: PropTypes.func,
};

export default AddShopProduct;
